export const APPLICATION_SUBMIT_RESPONSE = 'APPLICATION_SUBMIT_RESPONSE';

export const setApplicationSubmitResponseData = (data) => ({
  type: APPLICATION_SUBMIT_RESPONSE,
  data: data,
});
